import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    q: "Is this counselling or therapy?",
    a: "No. This is coaching. I do not diagnose or treat. If you need clinical mental-health support, please see a licensed therapist or psychiatrist. Coaching works best when you are stable and willing to do inner work.",
  },
  {
    q: "How do sessions happen?",
    a: "All sessions are on Zoom. You'll receive a link by email once your booking is confirmed.",
  },
  {
    q: "Why do you charge if this is a hobby?",
    a: "Because my time and training are valuable, and because paying clients tend to show up fully. The free clarity call is my gift; the rest honours the commitment we make to each other.",
  },
  {
    q: "Why is the listening session only for women?",
    a: "I have deliberately chosen to hold this particular space exclusively for women — it allows a kind of unguarded honesty that supports real release. Men are warmly welcome to the 6-day coaching.",
  },
  {
    q: "What if I'm not sure I'm ready?",
    a: "Start with the free 15-minute clarity call. If we're not the right fit, I'll tell you kindly — and may even suggest someone else.",
  },
  {
    q: "Do you offer refunds?",
    a: "Refunds are handled case-by-case before the programme begins. Once we've started, fees are non-refundable as I'll have committed time to you.",
  },
];

export default function FAQ() {
  return (
    <section id="faq" className="relative py-20 lg:py-28 bg-sunlit-cream/60" data-testid="faq-section">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-12 text-center">
          <p className="text-xs uppercase tracking-[0.2em] text-sunlit-mute mb-4">Gentle questions</p>
          <h2 className="font-serif-display text-4xl sm:text-5xl text-sunlit-ink leading-tight">
            Things people <span className="italic text-sunlit-gold">often wonder</span>.
          </h2>
        </div>

        <Accordion type="single" collapsible className="space-y-3" data-testid="faq-accordion">
          {faqs.map((f, idx) => (
            <AccordionItem
              key={idx}
              value={`item-${idx}`}
              className="rounded-2xl bg-sunlit-ivory border border-stone-200/70 px-6 data-[state=open]:shadow-md transition-all"
              data-testid={`faq-item-${idx}`}
            >
              <AccordionTrigger className="text-left text-base sm:text-lg font-medium text-sunlit-ink hover:no-underline py-5">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-sunlit-mute text-base leading-relaxed pb-5">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
